// extracted by mini-css-extract-plugin
module.exports = {"sections":"styles_sections__VzrIF","sectionsContent":"styles_sectionsContent__ofZjt"};